import { cn } from '@/utils/styles';

const checkBg =
  "checked:bg-[image:var(--checkbox-check)] checked:bg-no-repeat checked:bg-center checked:bg-[length:14px_14px]";

const indeterminateBg =
  "indeterminate:bg-[image:var(--checkbox-indeterminate)] indeterminate:bg-no-repeat indeterminate:bg-center indeterminate:bg-[length:14px_14px]";

export const colors = {
  primary: cn(
    // base
    'bg-white border-neutral-50 hover:border-primary-700',
    // focus
    'focus:border-primary-700 focus:ring-primary-50 focus:shadow-primary',
    // checked state
    'checked:border-primary-700 checked:bg-primary-700',
    'checked:hover:border-primary-800 checked:hover:bg-primary-800',
    checkBg,
    'indeterminate:border-primary-700 indeterminate:bg-primary-700',
    indeterminateBg,
    // disabled
    'disabled:border-neutral-50 disabled:bg-base-disabled',
    'disabled:checked:border-neutral-50 disabled:checked:bg-base-disabled'
  ),

  secondary: cn(
    'bg-white border-neutral-50 hover:border-base-primary',
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',
    'checked:border-secondary-accent checked:bg-secondary-accent',
    checkBg
  ),

  neutral: cn(
    'bg-white border-neutral-50 hover:border-base-primary',
    'focus:border-base-primary focus:ring-neutral-200 focus:shadow-sm',
    'checked:border-base-primary checked:bg-base-primary',
    checkBg
  ),

  warning: cn(
    'bg-white border-warning-400 hover:border-warning-400',
    'focus:border-warning-400 focus:ring-warning-200 focus:shadow-warning',
    'checked:border-warning-400 checked:bg-warning-400',
    checkBg
  ),

  error: cn(
    'bg-white border-secondary-accent/80 hover:border-secondary-accent',
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',
    'checked:border-secondary-accent checked:bg-secondary-accent',
    checkBg
  ),
};
